import { investorApi } from '@core/api/httpClient'
import { WALLET_ENDPOINTS } from './walletEndpointPaths'
import { parseWalletStatus } from './walletParser'
import type { WalletStatus } from '../types/walletTypes'

export async function getWalletStatus(offeringId: string): Promise<WalletStatus> {
  const { data } = await investorApi.get<unknown>(WALLET_ENDPOINTS.OFFERING_READINESS, {
    params: { offeringId },
  })
  return parseWalletStatus(data)
}
